import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import SimpleBackdrop from "../../utils/general";
import api from "../../utils/api";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant";
import { InputSwitch } from "primereact/inputswitch";
import { Dropdown } from "primereact/dropdown";

let configList = [
  {
    ConfigurationName: "Staff Access",
    ConfigurationValue: false,
  },
  {
    ConfigurationName: "Allow Negative Stock",
    ConfigurationValue: false,
  },
  {
    ConfigurationName: "2-factor Authentication",
    ConfigurationValue: false,
  },
  {
    ConfigurationName: "Invetory Bill",
    ConfigurationValue: false,
  },
  {
    ConfigurationName: "Limit Days",
    ConfigurationValue: "30",
  },
  {
    ConfigurationName: "Discount",
    ConfigurationValue: "percentage",
  },
  {
    ConfigurationName: "POS Discount",
    ConfigurationValue: "5",
  },
];

let defaultValues = {
  "Staff Access": false,
  "Allow Negative Stock": false,
  "2-factor Authentication": false,
  "Invetory Bill": false,
  "Limit Days": "30",
  Discount: "percentage",
  "POS Discount": "5",
};

class GeneralConfiguration extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      MasterID: "",
      loading: false,
      UserId: "",
      Token: "",
      GetMasterList: [],
      rowsPerPageOptions: CommonConfig.dataTableConfig.rowsPerPageOptions,
      rowsPerPage: CommonConfig.dataTableConfig.rowsPerPage,
      search: null,
      userPageAccess: [],
      debounceTimers: {},
    };
  }

  componentDidMount = async () => {
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");
    // if (lockstatus == 0) {
    if (token !== null) {
      this.setState({
        UserId: data,
        Token: token,
        userPageAccess: userPageAccess,
      });
      await this.GetGeneralConfiguration(data);
    } else {
      this.props.history.push("/login");
    }
    // } else {
    //     this.props.history.push('/auth/lockscreen')
    // }
  };

  GetGeneralConfiguration = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetGeneralConfiguration, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          let tempConfigurationList = configList.map((item) => {
            let tempConfig = filterArry.find(
              (config) => config.ConfigurationName === item.ConfigurationName
            );
            if (tempConfig) {
              return {
                ...tempConfig,
              };
            } else
              return {
                ...item,
                ConfigurationValue: defaultValues[item.ConfigurationName],
              };
          });

          this.setState({
            GetMasterList: tempConfigurationList,
          });
        }
      })
      .catch((err) => {});
  };

  UpdateGeneralConfiguration = (data, value) => {
    let params = {
      GeneralConfigurationID: data._id || "",
      ConfigurationName: data.ConfigurationName,
      ConfigurationValue: value,
      ConfigurationSymbol: value,
      UserID: this.state.UserId,
    };
    api
      .post(APIConstant.path.AddUpdateGeneralConfiguration, params)
      .then((res) => {
        if (res.Success == 1) {
          this.setState({ loading: false });
          this.GetGeneralConfiguration(this.state.UserId);
          cogoToast.success(res.Message);
        } else {
          this.setState({ loading: false });
          cogoToast.error(res.Message);
        }
      });
  };

  actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  actionBodyTemplate = (rowData, props) => {
    if (rowData.ConfigurationName === "Limit Days" || rowData.ConfigurationName === "POS Discount") {
      return (
        <InputText
          type="text"
          value={rowData.ConfigurationValue}
          onChange={(e) => {
            const value = e.target.value;
            const tempList = [...this.state.GetMasterList];

            if (/^\d*$/i.test(value) || value === "") {
              tempList[props.rowIndex].ConfigurationValue = value;
              tempList[props.rowIndex].ConfigurationSymbol = value;

              this.setState({ GetMasterList: tempList });

              // Debounce logic
              const timers = { ...this.state.debounceTimers };
              const configKey = rowData.ConfigurationName;

              if (timers[configKey]) {
                clearTimeout(timers[configKey]);
              }

              timers[configKey] = setTimeout(() => {
                this.UpdateGeneralConfiguration(rowData, value);
                const updatedTimers = { ...this.state.debounceTimers };
                delete updatedTimers[configKey];
                this.setState({ debounceTimers: updatedTimers });
              }, 800); // Delay in ms

              this.setState({ debounceTimers: timers });
            }
          }}
          maxLength={6}
          placeholder={rowData.ConfigurationName === "POS Discount" ? "Discount" : "Days"}
          size="10"
          style={{ marginRight: 10 }}
        />
      );
    }
    if (rowData.ConfigurationName === "Discount") {
      return (
        <Dropdown
          options={[
            { label: "Percentage", value: "percentage" },
            { label: "Value", value: "value" },
          ]}
          value={rowData.ConfigurationValue}
          onChange={(e) => {
            const val = e.value;
            const tempList = [...this.state.GetMasterList];
            tempList[props.rowIndex].ConfigurationValue = val;
            tempList[props.rowIndex].ConfigurationSymbol = val;
            this.UpdateGeneralConfiguration(rowData, val);
          }}
          placeholder="Packaging Type"
          className="p-w-100 e-input-common"
        />
      );
    } else {
      return (
        <InputSwitch
          checked={rowData.ConfigurationValue}
          onChange={(e) => {
            const tempList = [...this.state.GetMasterList];
            tempList[props.rowIndex].ConfigurationValue = e.value;
            tempList[props.rowIndex].ConfigurationSymbol = e.value;
            this.setState({ GetMasterList: tempList });
            this.UpdateGeneralConfiguration(rowData, e.value);
          }}
        />
      );
    }
  };

  render() {
    const { search, userPageAccess, GetMasterList } = this.state;

    let filterGetMasterList = [];
    if (GetMasterList.length) {
      filterGetMasterList = GetMasterList;
      if (search) {
        filterGetMasterList = filterGetMasterList.filter((x) => {
          return (
            x.ConfigurationName.toLowerCase().indexOf(search.toLowerCase()) !==
            -1
          );
        });
      }
    }

    return (
      <div className="wayment-owner-dashboard e-weighment-dashoard">
        <div className="heading-area p-d-flex p-ai-center p-jc-between">
          <div className="p-d-flex p-ai-center">
            <i className="pi pi-cog"></i>
            <h2>Configuration Master</h2>
          </div>
          <div className="p-d-flex p-ai-center wb-filter-btn">
            <div className="searchbar-area p-as-center p-position-relative">
              <InputText
                type="search"
                onInput={(e) => this.setState({ search: e.target.value })}
                placeholder="Global Search"
                size="30"
                style={{ marginRight: 30 }}
              />
              {!search ? <i className="icon-search"></i> : null}
            </div>
          </div>
        </div>
        <hr />
        <div className="custom-large-wb-table e-common-master-table">
          {this.state.loading === true ? (
            <div className="loading">
              <SimpleBackdrop />
            </div>
          ) : null}
          {userPageAccess?.includes("View General Configuration") ? (
            <DataTable
              className="main-table table-td"
              value={filterGetMasterList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              paginator={true}
              rows={this.state.rowsPerPage}
              totalRecords={filterGetMasterList.length}
              rowsPerPageOptions={this.state.rowsPerPageOptions}
              globalFilter={search}
              emptyMessage="No records found"
              responsive={false}
              resizableColumns={true}
              columnResizeMode="fit"
              scrollable={true}
              scrollWidth="auto"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            >
              <Column
                field="Index"
                header="Sr.No"
                body={this.actionBodyTemplateSrNo}
                style={{ width: "40%" }}
              ></Column>
              <Column
                field="ConfigurationName"
                header="Configuration Name"
                style={{ width: "50%" }}
              ></Column>
              <Column
                field="Action"
                header="Action"
                headerStyle={{ width: "10%" }}
                body={this.actionBodyTemplate}
              ></Column>
            </DataTable>
          ) : null}
        </div>
      </div>
    );
  }
}
export default GeneralConfiguration;
